export const formatDate = (dateString) =>
  new Intl.DateTimeFormat("en-GB").format(new Date(dateString));
